const company = function() {

    var currentTab = 'company';
    var currentContactId;

    this.on('tabFinish', function(e) {
        currentTab = e.tab;
    });

    $(document).on('click', '.createContactButton', function() {

        var form = new Esearcher.Helper.Form('contactForm');

        form.reset('companyPersonId', 'anrede', 'titel', 'vorname', 'nachname',
                'abteilung', 'funktion', 'geburtstag', 'telefon', 'skype',
                'mobil', 'icq', 'msn', 'telefax', 'aim', 'email', 'yahoo',
                'privateHP', 'klassifikation[1]', 'klassifikation[2]',
                'klassifikation[3]', 'klassifikation[4]', 'notizen');

        // nur fuer bereits existente Benutzer sinnvoll
        $('#contactEmail').remove();

        $('#blockContactPersonPicture .picture').html('');
    });

    function generateWriteStdDocUrl(documentId, companyId, personId, companyPersonId) {
        return '/write_stddok.php?did=' + documentId
                + '&fid=' + companyId
                + '&pid=' + personId
                + '&fpid=' + companyPersonId;
    }

    $(document).on('change', '.companyContactWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");

        var target = '/write_stddok.php?did=' + dataElement.data('actionId') +
            '&fid=' + $('#dataId').val() +
            '&pid=' + dataElement.data('contactId') +
            '&fpid=' + dataElement.data('companyContactId');

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '.companyWriteEmailToContactButton', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var writeUri = generateWriteStdDocUrl(
            $(this).attr('data-action-id'),
            $('#dataId').val(),
            $(this).attr('data-contact-id'),
            $(this).attr('data-company-contact-id')
        );

        Esearcher.Helper.navigation.redirect($(this).attr('data-back-url'),
            writeUri);
    });
};

export default company;
